module.exports = __webpack_public_path__ + "img/portuguese-sangria.1384b387.jpg";